import type {
  Actuator as SceneActuator,
  Body,
  BodyUUID,
  Equality,
  Joint,
  WorldBody,
} from "../../types/scene";

export type ActuatorControlNamingMode = "stableUuid" | "sceneName";
export type Actuator = SceneActuator & { type?: string };
export type MappedJoint = Joint & { type?: string; range?: [number, number]; ref?: number };

export type BodyRecord = Record<string, Body>;
export type JointRecord = Record<string, MappedJoint>;
export type EqualityRecord = Record<string, Equality>;
export type WorldBodyEntry = BodyUUID | WorldBody | { uuid: BodyUUID; rootBodyUuid?: BodyUUID };

export type MapperOptions = {
  bodies?: BodyRecord;
  worldBodies?: WorldBodyEntry[];
  equalities?: EqualityRecord;
  joints?: JointRecord;
};

export const getWorldBodyRootUuid = (entry: WorldBodyEntry): BodyUUID =>
  typeof entry === "string"
    ? entry
    : "rootBodyUuid" in entry && entry.rootBodyUuid
      ? entry.rootBodyUuid
      : entry.uuid;
